import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const EmpowerSection = () => {
  return (
    <section className="relative min-h-[80vh] overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-orange-400 via-orange-300 to-blue-300">
        {/* Decorative floating cubes */}
        <div className="absolute top-20 left-10 w-16 h-16 bg-gradient-to-br from-orange-500/30 to-orange-600/30 rounded-lg rotate-12 animate-float" />
        <div className="absolute top-40 left-20 w-12 h-12 bg-gradient-to-br from-orange-400/40 to-orange-500/40 rounded-lg -rotate-6 animate-float-delayed" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[60vh]">
          {/* Left - Glowing Sphere Image */}
          <div className="relative flex items-center justify-center">
            <div className="relative w-80 h-80 md:w-96 md:h-96">
              {/* Glowing background */}
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-400/50 to-blue-500/50 rounded-full blur-3xl animate-pulse" />
              
              {/* Main sphere */}
              <div className="relative w-full h-full rounded-full bg-gradient-to-br from-cyan-300 via-blue-400 to-blue-600 shadow-2xl overflow-hidden">
                {/* Network lines effect */}
                <div className="absolute inset-0">
                  <svg viewBox="0 0 400 400" className="w-full h-full opacity-60">
                    {/* Network dots */}
                    {[...Array(30)].map((_, i) => (
                      <circle
                        key={i}
                        cx={Math.random() * 400}
                        cy={Math.random() * 400}
                        r={2 + Math.random() * 3}
                        fill="white"
                        className="animate-pulse"
                        style={{ animationDelay: `${Math.random() * 2}s` }}
                      />
                    ))}
                    {/* Connecting lines */}
                    {[...Array(20)].map((_, i) => (
                      <line
                        key={`line-${i}`}
                        x1={Math.random() * 400}
                        y1={Math.random() * 400}
                        x2={Math.random() * 400}
                        y2={Math.random() * 400}
                        stroke="white"
                        strokeWidth="0.5"
                        opacity="0.3"
                      />
                    ))}
                  </svg>
                </div>
                
                {/* Glow spots */}
                <div className="absolute top-1/4 left-1/4 w-4 h-4 bg-white rounded-full blur-sm animate-ping" />
                <div className="absolute top-1/2 right-1/3 w-3 h-3 bg-cyan-200 rounded-full blur-sm animate-ping" style={{ animationDelay: '0.5s' }} />
                <div className="absolute bottom-1/3 left-1/2 w-5 h-5 bg-blue-200 rounded-full blur-sm animate-ping" style={{ animationDelay: '1s' }} />
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="text-right lg:pl-12">
            {/* Decorative light gray shape */}
            <div className="absolute top-0 right-0 w-80 h-80 bg-gray-200/30 rounded-full blur-3xl" />
            
            <div className="relative">
              <div className="flex items-center justify-end space-x-3 mb-4">
                <span className="text-gray-700 font-medium tracking-widest uppercase text-sm">
                  A Complete Business Solution
                </span>
                <div className="w-12 h-0.5 bg-gray-700" />
              </div>

              <h2 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6 leading-tight">
                Empower<br />
                <span className="relative">
                  Data & Innovation
                  <span className="absolute -bottom-2 right-0 w-full h-1 bg-orange-500/30" />
                </span>
              </h2>

              <p className="text-gray-700 text-lg mb-10 max-w-xl ml-auto">
                Merging innovation and expertise to elevate your digital journey.
              </p>

              <div className="flex flex-wrap justify-end gap-4">
                <Link to="/services">
                  <Button
                    className="bg-transparent border-2 border-slate-700 text-slate-700 hover:bg-slate-700 hover:text-white px-8 py-6 text-base font-medium rounded-full transition-all duration-300"
                  >
                    Transform with Us
                  </Button>
                </Link>
                <Link to="/capabilities">
                  <Button
                    className="bg-transparent border-2 border-slate-700 text-slate-700 hover:bg-slate-700 hover:text-white px-8 py-6 text-base font-medium rounded-full transition-all duration-300"
                  >
                    Capability
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 right-8">
        <div className="w-12 h-12 border-2 border-orange-500 rounded-full flex items-center justify-center cursor-pointer hover:bg-orange-500 hover:text-white transition-all">
          <svg className="w-5 h-5 text-orange-500 hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default EmpowerSection;
